import { Pagination } from 'antd';
import React, { useState } from 'react';
import Table from '../Table/Table';
import './Transactions.css';

const Transactions = ({ columns, data }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 100;

    const paginatedData = data.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    );

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const columnsWithIndex = [
        { header: '#', accessor: 'index' },
        ...columns
    ];

    const dataWithIndex = paginatedData.map((item, idx) => ({
        index: ((currentPage - 1) * pageSize) + idx + 1,
        ...item
    }));

    return (
        <div className="Transactions">
            <div className="TransactionsContent">
                <h1>Transferências</h1>
                <div className="TableContainer">
                    <Table columns={columnsWithIndex} data={dataWithIndex} />
                </div>
                {data.length > pageSize && (
                    <div className="TransactionsPagination">
                        <Pagination
                            current={currentPage}
                            total={data.length}
                            pageSize={pageSize}
                            onChange={handlePageChange}
                            showSizeChanger={false}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default Transactions;
